import { createEvent } from "@cobuildlab/react-simple-state";
import { Ranking } from "../../shared/types";

export const OnFetchRankings = createEvent<Ranking[]>();
export const OnFetchRankingsError = createEvent();
